import { defineMessages } from 'react-intl';

import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';

const messages = defineMessages({
  display: {
    id: 'Display',
    defaultMessage: 'Display',
  },
});
export const displayStyleSchema = ({ schema, formData, intl }) => {
  addStyling({ schema, intl });

  schema.properties.styles.schema.fieldsets[0].fields = [
    ...schema.properties.styles.schema.fieldsets[0].fields,
    'display',
  ];
  schema.properties.styles.schema.properties.display = {
    title: intl.formatMessage(messages.display),
    default: 'both',
    choices: [
      ['both', 'Both'],
      ['mobile', 'Mobile'],
      ['desktop', 'Desktop'],
    ],
  };

  return schema;
};
